import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  class: "link link--primary source-link",
  rel: "external",
  target: "_blank",
  href: "https://github.com/hqcasanova/pin-pad"
}, " Source ", -1)

import AppDisplay from '@/components/AppDisplay.vue';
import AppKeypad from '@/components/AppKeypad.vue';

import { useStore } from 'vuex';
import useValidation from '@/behaviours/useValidation';
import useLock from '@/behaviours/useLock';
import { computed, onMounted } from 'vue';

export type Props = {
  isResetOnTimeout?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    isResetOnTimeout: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isResetOnTimeout: boolean };



const store = useStore();
const { validateOnLength, isValidating } = useValidation();
const { timerOnFailcount, isPinLocked } = useLock();
const code = computed(() => store.state.code);
const validLength = computed(() => store.state.validLength);

validateOnLength();
timerOnFailcount(props.isResetOnTimeout); 

onMounted(() => {
  const appEl = document.querySelector('.app__container');
  appEl?.classList.add('app__container--loaded');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppDisplay, {
      code: _unref(code),
      "valid-length": _unref(validLength),
      "is-pin-locked": _unref(isPinLocked),
      "is-validating": _unref(isValidating)
    }, null, 8, ["code", "valid-length", "is-pin-locked", "is-validating"]),
    _createVNode(AppKeypad, {
      "is-disabled": _unref(isPinLocked),
      "is-input-blocked": _unref(isValidating)
    }, null, 8, ["is-disabled", "is-input-blocked"]),
    _hoisted_1
  ], 64))
}
}

})